import { searchProposalsRepository } from '@/infrastructure/proposals/proposals.repository';

import {
  buildSearchQuery,
  parseFiltersFromRoute,
  resolvePageFromHistory,
  savePageToHistory,
  filterProposalsNotShowingDoubleProposals,
} from '@/domain/proposal/search-proposal.domain';

const ROUTES_KEY = 'routes_visited';

// ─── Search proposals ───────────────────────────────────────

export function makeSearchProposalsUseCase(
  routeQuery,
  customFilters,
  networks,
  perPage,
  currentPage,
  vanity_name
) {
  return async function execute() {
    const query = buildSearchQuery(routeQuery, customFilters, networks);
    const response = await searchProposalsRepository.searchProposals(query, perPage, currentPage);

    return { count: response.count, results: vanity_name ? filterProposalsNotShowingDoubleProposals(response.results, vanity_name) : response.results };
  };
}

// ─── Load banners ───────────────────────────────────────────

export function makeLoadBannersUseCase(banner) {
  return async function execute() {
    const results = await searchProposalsRepository.getCollaborationBanners(banner);
    return results;
  };
}

// ─── Page persistence ───────────────────────────────────────

export function resolveInitialPage() {
  const raw = localStorage.getItem(ROUTES_KEY);
  if (!raw) return 1;
  const routes = JSON.parse(raw);
  return resolvePageFromHistory(routes);
}

export function persistCurrentPage(page) {
  const raw = localStorage.getItem(ROUTES_KEY);
  if (!raw) return;
  const routes = JSON.parse(raw);
  const updated = savePageToHistory(routes, page);
  localStorage.setItem(ROUTES_KEY, JSON.stringify(updated));
}

// ─── Parse route into filters ───────────────────────────────

export function extractFiltersFromRoute(routeQuery) {
  return parseFiltersFromRoute(routeQuery);
}
